import hoistStatics from 'hoist-non-react-statics';
import React, { Component } from 'react';
import { ReactReduxContext } from 'react-redux';

import { injectAsyncReducers } from 'shared/redux/store';
import { getDisplayName } from 'shared/utils';

const withAsyncReducers = reducers => WrappedComponent => {
  class withAsyncReducers extends Component {
    static contextType = ReactReduxContext;

    static displayName = `withAsyncReducers(${getDisplayName(
      WrappedComponent,
    )})`;

    state = {
      mounted: false,
    };

    componentDidMount() {
      injectAsyncReducers(this.context.store, reducers);
      this.setState({ mounted: true });
    }

    render() {
      return this.state.mounted ? <WrappedComponent {...this.props} /> : null;
    }
  }

  return hoistStatics(withAsyncReducers, WrappedComponent);
};

export default withAsyncReducers;
